import { token } from '@atlaskit/tokens';
import { css } from '@emotion/core';
import { N300 } from '@atlaskit/theme/colors';

import { SPACE_COZY } from '@/styles';

const popupWidth = 600;

export const sloLowTrafficHelperStyles = css`
  h5 {
    font-weight: 500;
  }
  width: ${popupWidth}px;
  img {
    width: 9px;
  }
`;

export const postfixStyles = css`
  font-size: 11px;
  text-transform: uppercase;
  font-weight: 500;
  color: ${token('color.text.accent.gray', N300)};
`;

export const infoBarStyles = css`
  padding: ${SPACE_COZY}px;
  background-color: ${token('color.background.input.hovered', N300)};
  border-radius: 3px;
`;
